// extracted by mini-css-extract-plugin
export default {"checkbox":"src-pages-StoreVoucher-Detail-UsageCondition-css-module__checkbox--YiYx1"};